export const mainSeoTexts = () => ({
  h1: 'Голос народа 2022',
  title: 'Голос народа - рейтинг от NUR.KZ',
  description: 'Проголосуйте в номинациях за любимый город, чиновника или проект. Именно ваш голос может стать решающим!', /* eslint-disable-line */
  canonical: ''
});

export const categorySeoTexts = (category, categoryIndex) => ({
  h1: `Номинанты в категории “${category.title}”`,
  title: `Номинации в категории “${category.title}” - Голос народа от NUR.KZ`,
  description: `Ознакомьтесь со списком номинаций Голоса народа в категории “${category.title}” и проголосуйте “за” или “против” представленных в них кандидатов.`, /* eslint-disable-line */
  canonical: `${categoryIndex !== 0 ? `${category.slug}/` : ''}`
});

export const nominationSeoTexts = (category, categoryIndex, nomination, nominationIndex) => {
  const canonicalUrl = nominationIndex /* eslint-disable-line */
    ? `${category.slug}/`
    : categoryIndex !== 0
      ? `${category.slug}/`
      : '';

  return {
    h1: nomination.title,
    title: `${nomination.title} - Голос народа от NUR.KZ`,
    description: `Список кандидатов в номинации “${nomination.title}” проекта Голос народа от NUR.KZ. Ознакомьтесь и проголосуйте “за” или “против” представленных номинантов.`, /* eslint-disable-line */
    canonical: canonicalUrl
  };
};

export const candidateSeoTexts = (category, nomination, candidate, categories) => {
  const currentCategory = categories.find(cat => cat.slug === category) || categories[0];
  const [firstNomination] = currentCategory.nominations;

  // this code was added by seo demands
  const canonicalUrl = category === 'cities'
    ? `${category}/${firstNomination.slug}/${candidate?.slug}/`
    : `${category}/${nomination}/${candidate?.slug}/`;

  let descriptionText = `Проголосуйте “за” или “против” ${candidate?.fullname} в Голосе народа от NUR.KZ.`;

  if (category === 'people') {
    descriptionText = `${candidate?.fullname} -  ознакомьтесь со списком достижений участника рейтинга и проголосуйте “за” или “против” него в Голосе народа от NUR.KZ.`; /* eslint-disable-line */
  }

  return {
    h1: candidate?.fullname,
    title: `${candidate?.fullname} - участник рейтинга Голос народа от NUR.KZ`,
    description: descriptionText,
    canonical: canonicalUrl
  };
};
